import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { useAuth } from '../../context/AuthContext';
import { useFieldLayout } from '../../hooks/useMedia';
import { SpiffTool } from '../../modules/SpiffToolLogs/components/SpiffTool';
import { SpiffLogPhone } from '../../modules/SpiffToolLogs/phone/SpiffLogPhone';

export const Route = createFileRoute('/spiffLog/')({
  component: RouteComponent,
  // Phones and tablets open a spiff as a page: in the URL, so a refresh keeps it and the phone's
  // Back steps out. Desktop doesn't read it.
  validateSearch: z.object({
    spiff: z.coerce.number().int().positive().optional(),
  }),
  loader(ctx) {
    const userFullName =
      ctx.context.authContext.user.firstname + ' ' + ctx.context.authContext.user.lastname;
    return {
      userFullName,
    };
  },
  head(ctx) {
    return {
      meta: [{ title: `Spiff Log - ${ctx.loaderData.userFullName}` }],
    };
  },
});

function RouteComponent() {
  const auth = useAuth();
  const isFieldLayout = useFieldLayout();
  const loggedUserId = auth.user.id;
  if (isFieldLayout) {
    return <SpiffLogPhone ownerId={loggedUserId} viewCreatedSpiffs={true} />;
  }
  return <SpiffTool type="Spiff" ownerId={loggedUserId} viewCreatedSpiffs={true} />;
}
